module.exports = __webpack_public_path__ + "img/home_welcome3_3.37297532.jpg";